<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-hover v-slot="{ hover }">

          <v-card :style="{border: 'white'}"
                  :class="hover?'elevation-1 rounded-lg pa-5 glass-effect-hover':'elevation-1 rounded-lg pa-5 glass-effect'">
            <v-row>
              <v-card-title>
                <span class="white--text ml-2">{{ title }}</span>
                <v-chip x-small
                        v-if="package.created_by || package.created_at"
                        style="font-size: 10px" color="back" class="white--text">
                  ساخته شده توسط
                  <span v-if="package.created_by" class="mr-1 ml-1 info--text font-weight-bold">

                  {{ package.created_by.name || package.created_by }}

                  </span>
                  در
                  <span class="mr-1  font-weight-bold" v-if="package.created_at">  {{ package.created_at }} </span>

                </v-chip>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        left
                        id="form-clear-btn"
                        @click.prevent="newForm()"
                        href="#/"
                        class="secondary mr-3 "
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-img max-height="20" max-width="20" src="/img/icons/new_form.svg"></v-img>
                    </v-btn>
                  </template>
                  ایجاد پکیج جدید
                </v-tooltip>
              </v-card-title>

            </v-row>
            <v-row>
              <v-col col="12" md="6">
                <v-text-field label="نام پکیج"
                              v-model="package.name" background-color="white" class="rounded-lg"
                              :disabled="!is_editing"/>

              </v-col>
              <v-col col="12" md="6">
                <v-text-field label="شماره فاکتور"
                              v-model="package.factor_number" background-color="white" class="rounded-lg"
                              :disabled="!is_editing"/>

              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="6">
                <date
                    v-model="package.registration_date"
                    label="تاریخ"
                    :default="false"
                    :disabled="!is_editing"/>
              </v-col>
              <v-col col="12" md="6">
                <mtime
                    v-model="package.registration_time"
                    label="ساعت"
                    :default="false"
                    :disabled="!is_editing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="12">
                <supplier-select
                    class="rounded-lg"
                    label=" تامین کننده"
                    v-model="package.supplier"
                    :disabled="!is_editing"
                ></supplier-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="12">
                <store-select
                    label=" تحویل به انبار"
                    v-model="package.store"
                    :disabled="!is_editing"
                ></store-select>
              </v-col>
            </v-row>
            <v-row v-if="package.is_inserted">
              <v-col col="12" md="12">
                <currency-select
                    class="rounded-lg"
                    label=" ارز"
                    v-model="package.currency"
                    :disabled="true"
                ></currency-select>
              </v-col>
            </v-row>
            <v-row v-if="package.id && !package.is_inserted">
              <v-col cols="12" md="12">
                <v-card :class="package.entrance_file?'success rounded-lg elevation-2':'primary rounded-lg elevation-2'"
                        @click="package.entrance_file?'':upload_file_dialog = true"
                        style="cursor: pointer">
                  <v-card-title>
                    <v-img
                        @click="upload_file_dialog = true"
                        class="mr-2"
                        style="cursor: pointer"
                        v-if="!package.entrance_file"
                        contain
                        max-height="25"
                        max-width="25"
                        src="/img/icons/info-white.svg"
                    />
                    <v-img
                        class="mr-2"
                        v-if="package.entrance_file"
                        contain
                        max-height="25"
                        max-width="25"
                        src="/img/icons/primary_check.svg"
                    />
                    <strong class="white--text mr-4" v-if="package.entrance_file">فایل اکسل آپلود شده </strong>
                    <strong class="white--text mr-4" v-if="!package.entrance_file"> فایل اکسل را آپلود کنید</strong>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="12" md="12" v-if="package_table">
                <v-simple-table>
                  <thead>
                  <tr>
                    <th class="text-center" v-for="(i, key) in (package_table[0])">
                      <v-btn
                          v-if="!check_number_in_row(key)"
                          block depressed
                          @click="setRow(key)"
                          class="secondary white--text rounded-lg"
                      >انتخاب
                      </v-btn>
                      <span v-else class="font-weight-bold primary--text">
                        <v-icon @click="remove_column(key)" color="error">fa-times</v-icon>
                        {{row_type_display(key)}}
                      </span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="row in package_table">
                    <td v-for="col in row" class="text-center">
                      {{ col }}
                    </td>
                  </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row v-if="package.id && package.is_inserted">
              <v-col cols="12" md="12">
                <v-table>
                  <thead>
                  <tr class="white--text">
                    <th class="text-center" style="font-size: x-small">
                      کد محصول
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      نام محصول
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      تعداد کارتون
                    </th>
                    <th class="text-center" style="font-size: x-small">
                       تعداد محصول در کارتون
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      قیمت خالص
                    </th>
                    <th class="text-center" style="font-size: x-small" @click="addInCaseOfSAleToAllRowsDialog=true">
                      نوع قیمت فروش
                    </th>
                    <th class="text-center cursor-pointer" style="font-size: x-small" @click="addInCaseOfSAleToAllRowsDialog=true">
                      نرخ فروش
                    </th>
                    <th class="text-center cursor-pointer" style="font-size: x-small">
                      درصورت فروش
                    </th>
                    <th class="text-center cursor-pointer" style="font-size: x-small" @click="addDiscountDialog=true">
                      نوع تخفیف
                    </th>
                    <th class="text-center cursor-pointer" style="font-size: x-small" @click="addDiscountDialog=true">
                      نرخ تخفیف
                    </th>
                    <th class="text-center cursor-pointer" style="font-size: x-small" @click="addDiscountDialog=true">
                      مبلغ نهایی
                    </th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in package.items">
                    <td class="text-center">
                      <v-text-field :disabled="!is_editing" class="rounded-lg" v-model="item.product_code"></v-text-field>
                    </td>
                    <td class="text-center">
                      <v-text-field :disabled="!is_editing" class="rounded-lg" v-model="item.default_name"></v-text-field>
                    </td>
                    <td class="text-center">
                      <money :disabled="!is_editing" v-model="item.number_of_box"></money>
                    </td>
                    <td class="text-center">
                      <money :disabled="!is_editing" v-model="item.number_of_products_per_box"></money>
                    </td>
                    <td class="text-center">
                      <money :disabled="!is_editing" v-model="item.net_purchase_price"></money>
                    </td>
                    <td class="text-center">
                      <v-autocomplete
                          class="rounded-lg"
                          :items="in_case_of_sale_types"
                          v-model="item.in_case_of_sale_type"
                          item-text="name"
                          :disabled="!is_editing"
                          item-value="value"
                      />
                    </td>
                    <td class="text-center">
                      <money :disabled="!is_editing" v-model="item.price_in_case_of_sale"></money>
                    </td>
                    <td class="text-center white--text pr-2 pl-2" style="font-size: smaller">
                      {{inCaseOfSaleCalculate(item) | toMoney}}
                    </td>
                    <td class="text-center">
                      <v-autocomplete
                          :disabled="!is_editing"
                          class="rounded-lg"
                          :items="in_case_of_sale_types"
                          v-model="item.discount_type"
                          item-text="name"
                          item-value="value"
                      />
                    </td>
                    <td class="text-center">
                      <money :disabled="!is_editing" v-model="item.discount"></money>
                    </td>
                    <td class="text-center white--text pr-2 pl-2" style="font-size: smaller">
                      {{discountCalculate(item) | toMoney}}
                    </td>

                  </tr>
                  </tbody>
                </v-table>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-row no-gutters class="d-flex flex-column-reverse flex-md-row mt-5">
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-start mt-2 mt-md-0">
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-end">
                  <div class="d-flex flex-wrap justify-center" v-if="!package.is_inserted">
                    <v-btn
                        v-if="package.entrance_file"
                        @click="removeExcel()"
                        depressed
                        color="error"
                        class="w-100px white--text rounded-lg ml-2"
                    >
                      <span>
                        بارگذاری مجدد
                      </span>
                    </v-btn>

                    <v-btn
                        @click="submitPackage()"
                        depressed
                        color="success"
                        class="w-100px  green white--text rounded-lg"
                        :disabled="(!package.entrance_file && package.id) ||
                         (package.entrance_file && excelRows.length == 0)"
                    >
                      <span v-if="!package.id">
                        ثبت اولیه
                      </span>
                      <span v-if="package.id">
                        ثبت پکیج
                      </span>
                    </v-btn>
                  </div>
                  <div class="d-flex flex-wrap justify-center" v-else>
                    <v-btn
                        @click="removeExcel()"
                        depressed
                        color="error"
                        class="w-100px white--text rounded-lg ml-2"
                    >
                      <span>
                        بارگذاری مجدد
                      </span>
                    </v-btn>
                    <v-btn
                        v-if="is_editing"
                        @click="updateItems()"
                        depressed
                        color="success"
                        class="w-100px white--text rounded-lg"
                    >
                      <span>
                        ثبت تغییرات
                      </span>
                    </v-btn>
                    <v-btn
                        v-else
                        @click="is_editing=true"
                        depressed
                        color="warning"
                        class="w-100px white--text rounded-lg"
                    >
                      <span>
                        ویرایش
                      </span>
                    </v-btn>
                  </div>
                </v-col>

              </v-row>
            </v-card-actions>
          </v-card>
        </v-hover>

      </v-col>


      <v-col cols="12" md="6">
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters"
                     ref="datatable" :show-select="false"
                     @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
        </m-datatable>


      </v-col>
    </v-row>


    <v-row justify="center">
      <v-dialog
          v-model="upload_file_dialog"
          class="rounded-lg"
          persistent
          @click:outside="upload_file_dialog=false"
          max-width="400"
      >
        <v-card class="rounded-lg">
          <v-card-title class="secondary white--text text-h5">
            فایل اکسل
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <m-file-input
                    v-model="entrance_file"
                    :delete-attachment.sync="delete_entrance_file"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="upload_file_dialog = false"
            >
              بستن
            </v-btn>
            <v-btn
                color="success"
                text
                @click="updateFile(package)"
            >
              ثبت
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog
          v-model="addRowDialog"
          class="rounded-lg"
          persistent
          @click:outside="closeAddExcelRowDialog()"
          max-width="300"
      >
        <v-card class="rounded-lg">
          <v-card-title class="secondary white--text">
            اضافه کردن ردیف
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <v-autocomplete
                    class="rounded-lg"
                    label="ستون"
                    :items="row_types"
                    v-model="row_type"
                    item-text="name"
                    item-value="value"
                />
              </v-col>
              <v-col cols="12" md="12" v-if="row_type == 'pp'">
                <currency-select
                    class="rounded-lg"
                    label=" ارز"
                    v-model="row_currency"
                ></currency-select>
              </v-col>
              <v-col cols="12" md="12" v-if="row_type == 'ic'">
                <v-autocomplete
                    class="rounded-lg"
                    label="نوع قیمت در صورت فروش"
                    :items="in_case_of_sale_types"
                    v-model="in_case_of_sale_type"
                    item-text="name"
                    item-value="value"
                />

              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="closeAddExcelRowDialog()"
            >
              بستن
            </v-btn>
            <v-btn
                color="success"
                text
                @click="addExcelRow()"
            >
              اضافه کردن
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="addInCaseOfSAleToAllRowsDialog"
          class="rounded-lg"
          persistent
          @click:outside="closeAddExcelRowDialog()"
          max-width="300"
      >
        <v-card class="rounded-lg">
          <v-card-title class="secondary white--text">
            نرخ فروش تجمیعی
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <v-autocomplete
                    label="نوع نرخ فروش"
                    class="rounded-lg"
                    :items="in_case_of_sale_types"
                    v-model="inCaseOfSaleType"
                    item-text="name"
                    item-value="value"
                />
              </v-col>
              <v-col cols="12" md="12">
                <money label="نرخ" v-model="inCaseOfSaleValue" class="rounded-lg"></money>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="closeAddInCaseOfSAleToAllRowsDialog()"
            >
              بستن
            </v-btn>
            <v-btn
                color="success"
                text
                @click="changeInCaseOfSale()"
            >
              تغییر نرخ فروش
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="addDiscountDialog"
          class="rounded-lg"
          persistent
          @click:outside="closeDiscountDialog()"
          max-width="300"
      >
        <v-card class="rounded-lg">
          <v-card-title class="secondary white--text">
            تخفیف تجمیعی
          </v-card-title>
          <v-card-text class="pa-5">
            <v-row>
              <v-col cols="12" md="12">
                <v-autocomplete
                    label="نوع تخفیف"
                    class="rounded-lg"
                    :items="in_case_of_sale_types"
                    v-model="discountType"
                    item-text="name"
                    item-value="value"
                />
              </v-col>
              <v-col cols="12" md="12">
                <money label="نرخ تخفیف" v-model="discountValue" class="rounded-lg"></money>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                text
                @click="closeDiscountDialog()"
            >
              بستن
            </v-btn>
            <v-btn
                color="success"
                text
                @click="changeDiscount()"
            >
              تغییر نرخ فروش
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import Time from "@/components/mcomponents/cleave/Time";
import StoreSelect from "@/components/selects/StoreSelect";
import CurrencySelect from "@/components/selects/CurrencySelect";
import SupplierSelect from "@/components/selects/SupplierSelect";


export default {
  name: "EntrancePackage",
  components: {SupplierSelect, CurrencySelect, StoreSelect, Time},
  mixins: [MFormMixin, formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      url: "entrance/lists/entrancePackage",
      filters: {},
      row_type: null,
      row_currency: null,
      row_number: null,
      addRowDialog: false,
      is_editing: true,
      excelRows: [],
      package: {},
      package_table: null,
      upload_file_dialog: false,
      addInCaseOfSAleToAllRowsDialog: false,
      inCaseOfSaleType: null,
      inCaseOfSaleValue: null,
      addDiscountDialog: false,
      discountType: null,
      discountValue: null,
      entrance_file: null,
      delete_entrance_file: null,
      submit_types: [
        {name: ' دستی', value: true},
        {name: 'فایل اکسل', value: false},
      ],
      row_types: [
        {name: ' مبلغ محصول', value: 'pp'},
        {name: 'نام محصول', value: 'pn'},
        {name: 'کد محصول', value: 'pc'},
        {name: 'تعداد کارتون', value: 'nb'},
        {name: 'تعداد محصول در کارتون', value: 'pb'},
        {name: 'تعداد محصول', value: 'pb'},
        {name: 'کد 16 رقمی', value: 'sd'},
        {name: 'قیمت در صورت فروش', value: 'ic'},
        {name: 'بارکد', value: 'ba'},
        {name: 'تصویر', value: 'im'},
        {name: 'مبلغ کل', value: 'ps'},

      ],
      in_case_of_sale_types: [
        {name: 'مبلغ', value: 'a'},
        {name: 'درصد', value: 'p'},
      ],
    };
  },
  computed: {
    title() {
      return 'پکیج'
    },
    headers() {
      return [
        {
          text: "نام",
          value: "name",
        },
        {
          text: "تاریخ",
          value: "registration_date",
          type: "date",
        },

      ];
    },
  },
  updated() {
  },
  created() {
    if (this.id) {
      this.getPackage()
      this.is_editing = false
    }
  },
  watch: {
    id() {
      if (this.id) {
        this.excelRows = []
        this.package_table = null
        this.getPackage()
      }
    }
  },
  methods: {
    type_display(row_type) {
      for (let row of this.row_types) {
        if (row['value'] == row_type) {
          return row['name']
        }
      }
      return ''
    },

    to(item) {
      return {
        name: "EntrancePackage",
        params: {
          id: item.id,
        },
      };
    },

    getFileSerialized(selectItem) {
      let item = {
        id: selectItem.id,
        entrance_file: this.entrance_file,
        delete_entrance_file: this.entrance_file,
      };

      if (typeof item["entrance_file"] == typeof "") {
        delete item["entrance_file"];
      }

      return this.jsonToFormData(item);
    },
    getPackageTable(id) {
      this.request({
        url: this.endpoint(`entrance/packageTable/${id}`),
        method: "get",
        success: data => {
          this.package_table = data.result
        }
      })
    },

    updateFile(selectItem) {
      this.request({
        url: this.endpoint(`entrance/fileUpload/${selectItem.id}`),
        method: "put",
        data: this.getFileSerialized(selectItem),
        success: (data) => {
          this.isEditing = false;
          this.upload_file_dialog = false
          this.getPackageTable(selectItem.id)
          this.getPackage()
        },
      });
    },
    updateItems() {
      this.request({
        url: this.endpoint(`entrance/updateEntranceItems`),
        method: "put",
        data: this.package.items,
        success: (data) => {
          this.getPackage()
          this.is_editing = false
        },
      });
    },
    getPackage() {
      this.request({
        url: this.endpoint(`entrance/package/${this.id}`),
        method: "get",
        success: data => {
          this.package = data
          if (data.entrance_file) {
            this.getPackageTable(data.id)
          }
        }
      })
    },
    closeAddExcelRowDialog() {
      this.addRowDialog = false
      this.row_number = null
      this.row_currency = null
      this.row_type = null
      this.in_case_of_sale_type = null
    },
    closeAddInCaseOfSAleToAllRowsDialog() {
      this.addInCaseOfSAleToAllRowsDialog = false
      this.inCaseOfSaleType = null
      this.inCaseOfSaleValue = null
    },
    closeDiscountDialog() {
      this.addDiscountDialog = false
      this.discountType = null
      this.discountValue = null
    },
    changeInCaseOfSale(){
      for (let item of this.package.items) {
        item.in_case_of_sale_type = this.inCaseOfSaleType
        item.price_in_case_of_sale = this.inCaseOfSaleValue
      }
      this.closeAddInCaseOfSAleToAllRowsDialog()

    },
    changeDiscount(){
      for (let item of this.package.items) {
        item.discount_type = this.discountType
        item.discount = this.discountValue
      }
      this.closeDiscountDialog()
    },
    setRow(row_number) {
      this.row_number = row_number
      this.addRowDialog = true
    },
    submitPackage() {
      if (!this.package.id){
        this.request({
          url: this.endpoint(`entrance/entrancePackage`),
          method: "post",
          data: this.package,
          success: data => {
            this.package = data
            this.changeRouteTo(data.id)
            this.$refs.datatable.getDataFromApi()
          }
        })
      } else {
        this.submitExcelRows(this.package.id)

      }

    },
    check_number_in_row(row_number) {
      for (let row of this.excelRows) {
        if (row['column_number'] == row_number) {
          return true
        }
      }
      return false
    },
    row_type_display(row_number) {
      for (let row of this.excelRows) {
        if (row['column_number'] == row_number) {
          return this.type_display(row['key'])
        }
      }
      return ''
    },
    get_column(row_number) {
      for (let row of this.excelRows) {
        if (row['column_number'] == row_number) {
          return row
        }
      }
      return null
    },

    remove_column(row_number) {
      this.excelRows.splice(this.excelRows.indexOf(this.get_column(row_number)), 1);
    },
    newForm() {
      this.package = {}
      this.is_editing = true
      this.excelRows = []
      this.package_table = null
      this.entrance_file = null
      this.changeRouteTo(null)
    },
    inCaseOfSaleCalculate(item) {
      if (item.in_case_of_sale_type == 'a') {
        return parseInt(item.net_purchase_price) + parseInt(item.price_in_case_of_sale)
      } else {
        return parseInt(item.net_purchase_price) + (parseInt(item.net_purchase_price) *
            parseInt(item.price_in_case_of_sale) / 100)
      }
    },
    discountCalculate(item) {
      if (item.discount_type == 'a') {
        return this.inCaseOfSaleCalculate(item) - item.discount
      } else {
        let price = this.inCaseOfSaleCalculate(item)
        return price - (price * item.discount / 100)
      }
    },
    addExcelRow() {
      this.excelRows.push(
          {
            key: this.row_type,
            column_number: this.row_number,
            is_in_case_of_sale: this.row_type == 'ic',
            currency: this.row_currency,
          }
      )
      this.closeAddExcelRowDialog()
    },
    submitExcelRows(id) {
      this.request({
        url: this.endpoint(`entrance/entrancePackageInsertExcel`),
        method: "post",
        data: {
          packages_columns: this.excelRows,
          entrance_package: id,
          currency: this.row_currency,
        },
        success: (data) => {
          this.getPackage()
        },
      });

    },
    removeExcel() {
      this.request({
        url: this.endpoint(`entrance/removeExcel/${this.id}/`),
        method: "delete",
        success: (data) => {
          this.package_table = null
          this.excelRows = []
          this.getPackage()
        },
      });

    }



  },
}
</script>

<style scoped lang="scss">
.glass-effect {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(
          5px
  );
}

.glass-effect-hover {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(20px);
}
.cursor-pointer {
  cursor: pointer !important;
}

</style>

